import { render, staticRenderFns } from "./PublicSeaClueList.vue?vue&type=template&id=14a96172&scoped=true"
import script from "./PublicSeaClueList.vue?vue&type=script&lang=js"
export * from "./PublicSeaClueList.vue?vue&type=script&lang=js"
import style0 from "./PublicSeaClueList.vue?vue&type=style&index=0&id=14a96172&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a96172",
  null
  
)

export default component.exports